import React from 'react';

const NotFoundMessage = () => (
  <div className="not-found">
    <p>No recipes found</p>
  </div>
);

export default NotFoundMessage;
